<template>
  <v-simple-table>
    <tr>
      <td>
        <image-icon
          :image="image"
          :row-type="rowType"
        ></image-icon>
      </td>
      <td>
        <v-simple-table>
          <tr v-if="storyHeader">
            <td>
              <span class="subtitle-1 pl-1">{{storyHeader}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span v-if="story">
                <div v-for="(sto,index) in story" :key=index>
                  <Story :story="sto"></Story>
                </div>
              </span>
              <span v-else>
                {{noInformation}}
              </span>
            </td>
          </tr>
        </v-simple-table>
      </td>
    </tr>
  </v-simple-table>
</template>
<script>

import Imageicon from '@/components/Imageicon'
import Story from '@/components/Story'
import { SearchUtils } from '@/js'

import { mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
export default {
  props: {
    itemReason: Object,
    allPrizes: Array,
    storyHeader: String,
    rowType: String,
    missingInformation: String
  },
  components: {
    'image-icon': Imageicon,
    Story,
  },
  computed: {
    noInformation () {
      return this.missingInformation || ''
    },
    isFilm () {
      return this.rowType === 'film' || this.rowType === 'vimeofilm'
    },
    image () {
      const path = this.isFilm &&
        this.activeSlide &&
        this.activeSlide.best &&
        this.activeSlide.best.path
      return path || SearchUtils.getImageFromReason({
        reason: this.itemReason,
        rowType: this.rowType,
        big: true
      })
    },
    story () {
      const story = SearchUtils.getStoryFromReason({ reason: this.itemReason, rowType: this.rowType, allPrizes: this.allPrizes })
      return story
    },
    ...mapGetters(vxMaps.getters)
  }

}
</script>
